import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, IObjectResponse } from '@nkr/store/index';
import { Row, Col, FormControl, Well } from 'react-bootstrap';
import { ChangeEvent, FormEvent } from 'react';
import Grid from './grid';
import * as qs from 'query-string';
import * as moment from 'moment';
import { ActionsReportDonorsProtected, IDonorsProtectedReport, IDonorsProtectedReportDetail } from '@nkr/store/reports/donors-protected';

interface IProps {

}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonorsProtectedReport: (centerId: number, endDate: string) => Promise<IObjectResponse<IDonorsProtectedReportDetail<IDonorsProtectedReport>>>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    data: IDonorsProtectedReport[],
    reportStart: string,
    reportEnd: string,
    centerId: number
}

class DonorsProtectedReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        reportStart: null,
        reportEnd: null,
        centerId: 0
    }

    componentDidMount = () => {
        this.getData(`Getting Donors Protected Report, one moment please...`);
    }

    getData = (message: string) => {
        let parsed = qs.parse(location.search);
        let centerId = parsed?.ctrID;
        let endDate = moment(parsed?.endDate, "YYYY-MM-DD", true);
        endDate = endDate.isValid() ? endDate : null;
        let endDateStr = endDate?.format("YYYY-MM-DD") ?? "";

        this.props.showLoading(message).then(() => {
            this.props.getDonorsProtectedReport(centerId, endDateStr).then(response => {
                let data = response.data;

                this.setState({
                    data: data.result.data,
                    reportStart: data.result.startDate,
                    reportEnd: data.result.endDate,
                    centerId: centerId
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    refreshReport = (e: FormEvent<FormControl & HTMLInputElement>) => {
        const newUrl = `${window.location.pathname}?ctrID=${this.state.centerId}&endDate=${e.currentTarget.value}`;
        history.pushState(null, '', newUrl);
        this.getData(`Getting Donors Protected Report, one moment please...`);
    }

    getPercent = (value: number, total: number) => {
        return total == 0 ? "N/A" : `${Math.floor((value / total) * 100)}%`;
    }

    render = () => {
        const reportStart = moment(this.state.reportStart, "YYYY-MM-DD", true).format("MM/DD/YYYY");
        const reportEnd = this.state.reportEnd;
        const data = this.state.data;
        const kidneyProtectedFully = _.sumBy(data, (x) => x.kidneyDonorsFullyProtected);
        const kidneyProtected = _.sumBy(data, (x) => x.kidneyDonorsProtected);
        const kidneyTotal = _.sumBy(data, (x) => x.kidneyDonorsTotal);
        const liverProtected = _.sumBy(data, (x) => x.liverDonorsProtected);
        const liverTotal = _.sumBy(data, (x) => x.liverDonorsTotal);
        const centerAlias = _.first(data)?.centerAlias;

        return (
            <>
                <h2>{centerAlias} - Donors Protected by Donor Shield</h2>
                <Well bsSize='sm' style={{ marginBottom: 0 }}>
                    <Row>
                        <Col xs={6}>
                            <div className="form-horizontal">
                                <div className="form-group">
                                    <label className="col-xs-4 control-label">Report Range:</label>
                                    <div className="col-xs-8">
                                        <div className="form-inline">
                                            <div className="form-control-static">&nbsp; {reportStart} &nbsp;-&nbsp;</div>
                                            <FormControl className="form-control" type="date" onChange={this.refreshReport} value={reportEnd} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col className="form-inline" xs={6}>
                            <table className="table table-condensed table-striped">
                                <thead>
                                    <tr>
                                        <th>Stat</th>
                                        <td className="text-center">Protected</td>
                                        <td className="text-center">Total</td>
                                        <td className="text-center">% Protected</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Kidney Donors</td>
                                        <td className="text-center">{kidneyProtected}</td>
                                        <td className="text-center">{kidneyTotal}</td>
                                        <td className="text-center">{this.getPercent(kidneyProtected, kidneyTotal)}</td>
                                    </tr>
                                    <tr>
                                        <td>Liver Donors</td>
                                        <td className="text-center">{liverProtected}</td>
                                        <td className="text-center">{liverTotal}</td>
                                        <td className="text-center">{this.getPercent(liverProtected, liverTotal)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Well>

                <Grid data={data} />

            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorsProtectedReport: (centerId, endDate) => {
            return dispatch(ActionsReportDonorsProtected.getDonorsProtected(centerId, endDate));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorsProtectedReport);